import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TeacherListElementVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { adminRetrieveTeachers } from "./retrieve-teachers";

const initialState: RetrievalState<TeacherListElementVM[]> = { fetching: "idle", data: [] };

export const retrieveTeachersReducer = createReducer<RetrievalState<TeacherListElementVM[]>>(initialState, builder => {
  builder.addCase(adminRetrieveTeachers.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveTeachers.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveTeachers.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
